<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editData" ref="editDataRef" label-width="220px">
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">任务当前进度(必填,百分比)</span>
            </label>
            <el-input v-model="editData.workprogress" placeholder="请输入任务当前进度"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">任务当前情况简报(必填)</span>
            </label>
            <el-input v-model="editData.workreport" placeholder="请输入任务当前情况简报" type="textarea" :rows="5"></el-input>
          </el-form-item>
          <el-form-item label="任务核心交付物内容(选填)" class="addAdminForm">
            <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      editData: {
        workprogress: '',
        workreport: '',
        workkeyfile: ''
      },
      parentdata: null
    }
  },
  mounted () {

  },
  methods: {
    LoadData (parentdata) {
      this.$refs.MultiImgOrPdf.cleardata()

      this.parentdata = parentdata
      this.editData.workprogress = this.parentdata.workprogress
      this.editData.workreport = this.parentdata.workreport
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apieditData()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.editData.workkeyfile = url
    },
    apieditData: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        workbenchid: that.parentdata.workbenchid,
        workprogress: that.editData.workprogress,
        workreport: that.editData.workreport,
        workkeyfile: that.editData.workkeyfile
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_PostWorkbenchsingleProgress, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
